module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"Are you sure you want to cancel local delivery arrangement for order {orderNumber}?","cancel":"Cancel","confirm":"Confirm"},"id":{"message":"Anda yakin ingin membatalkan pengaturan pengiriman lokal untuk pesanan {orderNumber}","cancel":"Batal","confirm":"Konfirmasi"}}')
  delete Component.options._Ctor
}
